var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('el-card',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"设置工作地点"}},[_c('Jobsite')],1),_c('el-tab-pane',{attrs:{"label":"设置公司名称"}},[_c('Company')],1),_c('el-tab-pane',{attrs:{"label":"设置班制管理"}},[_c('Workshift')],1),_c('el-tab-pane',{attrs:{"label":"设置用工形式"}},[_c('Contract')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }